import CircleIcon from '@mui/icons-material/Circle';
import { Timeline, TimelineItem } from '@mui/lab';
import { Grid, Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  BiDetail,
  BiEnvelope,
  BiHistory,
  BiMessageDetail,
  BiPhone,
  BiTimeFive,
} from 'react-icons/bi';
import { useParams } from 'react-router-dom';
import {
  IOurEntity,
  getOurEntityById,
  getActivityLogs,
  getActivityLogsByEntity,
  ActivityLogDTO,
} from 'wisestep-api';
import {
  WsTitleBanner,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  formatDateInDayMonthYearTime,
  WsColors,
  WsTimeLine,
} from 'wisestep-base';

import CommunicationBar from '../../../components/communicationBar/CommunicationBar';
import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import { WsTabs } from '../../../components/WsTabs';
import { WsActivityProps } from '../../../features/activityLog/ActivityHelper';
import { getClientsBreadCrumbList } from '../../../features/clientDetails/helper/clientDetailsHelper';
import { OurEntityAction, useOurEntityAuthz } from '../../../hooks/useOurEntityAuthz';
import ShowOurEntityDetail from '../component/ShowOurEntityDetail';

import { ShowOurEntityBanking } from './ShowOurEntityBanking';
import { ShowOurEntityLegalIdentifier } from './ShowOurEntityLegalIdentifier';
import { ShowOurEntitySignatory } from './ShowOurEntitySignatory';
import { ShowOurEntityTaxation } from './ShowOurEntityTaxation';

type OurEntityPageParams = {
  ourEntityId: string;
};

export const getOurEntityDetailsUrl = (id) => `/organisationEntity/${id}/details`;

const OurEntityDetail = () => {
  const isAuthorizedViewOurEntityDetails = useOurEntityAuthz(OurEntityAction.VIEW_ENTITY_DETAILS);
  const isAuthorizedViewOurEntityLegal = useOurEntityAuthz(
    OurEntityAction.VIEW_ENTITY_LEGAL_IDENTIFIERS
  );
  const isAuthorizedViewOurEntityBanking = useOurEntityAuthz(
    OurEntityAction.VIEW_ENTITY_BANKING_INFORMATION
  );
  const isAuthorizedViewOurEntitySignatory = useOurEntityAuthz(
    OurEntityAction.VIEW_ENTITY_SIGNATORY_INFORMATION
  );
  const [ourEntityData, setOurEntityData] = useState<IOurEntity>({
    Name: '',
  });
  const params = useParams<OurEntityPageParams>();
  const [getActivityData, setgetActivityData] = useState<ActivityLogDTO[]>([]);
  const activityLists: WsActivityProps[] = [];

  const ourEntityId: string = params.ourEntityId ?? '';

  useEffect(() => {
    let avtivityLog: any = [];
    const getOurEntityDetail = async () => {
      const response = await getOurEntityById(ourEntityId);
      setOurEntityData(response.data.data);
      const { data: actvityResponseContext } = await getActivityLogs(ourEntityId ?? '');
      const { data: actvityResponseEnitiy } = await getActivityLogsByEntity(ourEntityId ?? '');
      avtivityLog = actvityResponseContext.concat(actvityResponseEnitiy);
      const uniqueAvtivityLog = avtivityLog.filter((obj, index) => {
        return index === avtivityLog.findIndex((o) => obj.id === o.id);
      });
      setgetActivityData(uniqueAvtivityLog);
    };
    getOurEntityDetail();
  }, [ourEntityId]);

  getActivityData?.map((data: ActivityLogDTO) =>
    activityLists.push({
      activity: (
        <TimelineItem>
          <Grid container>
            <Grid item xs={12}>
              <WsTypography color={WsTypoColors.TERTIARY}>
                {` At ${formatDateInDayMonthYearTime(data?.createdOn!.toString())} by ${
                  data.createdByName
                }`}
              </WsTypography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant={WsTypoVariants.SUB_TITLE}>
                <>{`${data.field} Category -> ${data.description} Organisation Entity ${data.parentEntitiyName}`}</>
              </Typography>
            </Grid>
          </Grid>
        </TimelineItem>
      ),
      leftChildren: <CircleIcon sx={{ color: WsColors.TheBlues600 }} fontSize={'small'} />,
    })
  );

  return (
    <>
      <Box borderRadius={1.5}>
        {ourEntityData && (
          <>
            <WsBreadCrumbs
              breadCrumbsList={getClientsBreadCrumbList(
                'ORGANIZATION_ENTITY',
                ourEntityData?.Name ?? ''
              )}
            />
            <WsTitleBanner title={ourEntityData?.Name} backButton={false} />
          </>
        )}
        <WsTabs>
          {isAuthorizedViewOurEntityDetails && (
            <WsTabs.Item label="Organisation Details">
              <ShowOurEntityDetail labelText="Organisation Details" ourEntityData={ourEntityData} />
            </WsTabs.Item>
          )}
          {isAuthorizedViewOurEntityLegal && (
            <WsTabs.Item label="Legal identifiers">
              <ShowOurEntityLegalIdentifier ourEntityId={ourEntityId} />
            </WsTabs.Item>
          )}
          {isAuthorizedViewOurEntityBanking && (
            <WsTabs.Item label="Banking Information">
              <ShowOurEntityBanking ourEntityId={ourEntityId} />
            </WsTabs.Item>
          )}
          {isAuthorizedViewOurEntitySignatory && (
            <WsTabs.Item label="Signatory Information">
              <ShowOurEntitySignatory ourEntityId={ourEntityId} />
            </WsTabs.Item>
          )}
          <WsTabs.Item label="Taxation">
            <ShowOurEntityTaxation ourEntityId={ourEntityId} />
          </WsTabs.Item>
        </WsTabs>
      </Box>
      <>
        <CommunicationBar>
          <CommunicationBar.Item title="Activity log!" icon={BiHistory}>
            <Box m={2}>
              {getActivityData && (
                <Timeline>
                  <Box ml="-100%">
                    <WsTimeLine activityList={activityLists} timeLineDotVariant={'outlined'} />
                  </Box>
                </Timeline>
              )}
            </Box>
          </CommunicationBar.Item>
          <CommunicationBar.Item title="Notes" icon={BiDetail}>
            <></>
          </CommunicationBar.Item>
          <CommunicationBar.Item title="Coming soon!" icon={BiTimeFive}>
            <></>
          </CommunicationBar.Item>
          <CommunicationBar.Item title="Coming soon!" icon={BiMessageDetail}>
            <></>
          </CommunicationBar.Item>
          <CommunicationBar.Item title="Coming soon!" icon={BiEnvelope}>
            <></>
          </CommunicationBar.Item>
          <CommunicationBar.Item title="Coming soon!" icon={BiPhone}>
            <></>
          </CommunicationBar.Item>
        </CommunicationBar>
      </>
    </>
  );
};

export default OurEntityDetail;
